import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { publishSong } from "../../store/reducers/builderReducer"
import { Centered } from "../common/centered/Centered"
import { CustomH2 } from "../common/customH2/CustomH2"
import { AppLink } from "../common/link/AppLink"
import styles from './Upload.module.css'

export const Upload = () => {
    const { isFetching } = useSelector(state => state.builder)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const handleUpload = async () => {
        try {
            await dispatch(publishSong())
            navigate('/builder/finish')
        } catch (e) {
            alert(e.code)
        }
    }

    return <Centered>
        <CustomH2>We're ready to upload your stuff. What about you?</CustomH2>
        <div className={styles.buttons}>
            <AppLink to={'/builder/files'}>Go Back</AppLink>
            <AppLink action={handleUpload}>Upload</AppLink>
        </div>
        {isFetching && <div>Uploading...</div>}
    </Centered>
}